// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getQuestionTypes as listQuestionTypesAPI,
    getQuestionType as getQuestionTypeAPI,
    addQuestionType as addQuestionTypeAPI,
    updateQuestionType as updateQuestionTypeAPI,
    deleteQuestionType as deleteQuestionTypeAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { questionTypesApiResponseError, questionTypesApiResponseSuccess } from './actions';
import { QuestionTypesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getQuestionType({ payload: { id } }) {
    try {
        const response = yield call(getQuestionTypeAPI, id );
        const questionTypeItem = response.data.data;
        yield put(questionTypesApiResponseSuccess(QuestionTypesActionTypes.GET_QUESTION_TYPE, questionTypeItem));
    } catch (error) {
        yield put(questionTypesApiResponseError(QuestionTypesActionTypes.GET_QUESTION_TYPE, error));
    }
}

function* addQuestionType({payload:questionType}){
    try{
        const response = yield call(addQuestionTypeAPI,{...questionType})
        const questionTypeItem = response.data
        yield put(questionTypesApiResponseSuccess(QuestionTypesActionTypes.ADD_QUESTION_TYPE,questionTypeItem))
    } catch(error){
        yield put(questionTypesApiResponseError(QuestionTypesActionTypes.ADD_QUESTION_TYPE,error))
    }
}

function* updateQuestionType({payload:questionType}){
    try{
        const response = yield call(updateQuestionTypeAPI,{...questionType})
        const questionTypeItem = response.data.data
        yield put(questionTypesApiResponseSuccess(QuestionTypesActionTypes.UPDATE_QUESTION_TYPE,questionTypeItem))
    }catch(error){
        yield put(questionTypesApiResponseError(QuestionTypesActionTypes.UPDATE_QUESTION_TYPE,error))
    }
}
function* deleteQuestionType({payload:{id}}){
    try{
        const response = yield call(deleteQuestionTypeAPI,id)
        const questionTypeItem = response.data.id
        yield put(questionTypesApiResponseSuccess(QuestionTypesActionTypes.DELETE_QUESTION_TYPE,questionTypeItem))
    }catch(error){
        yield put(questionTypesApiResponseError(QuestionTypesActionTypes.DELETE_QUESTION_TYPE,error))
    }
}

/**
 * List contactos
 */
function* listQuestionTypes({payload:params}) {
    try {
        const response = yield call(listQuestionTypesAPI, { ...params });
        const listaQuestionTypes = response.data.data;
        yield put(questionTypesApiResponseSuccess(QuestionTypesActionTypes.LIST_QUESTION_TYPES, listaQuestionTypes));
    } catch (error) {
        yield put(questionTypesApiResponseError(QuestionTypesActionTypes.LIST_QUESTION_TYPES, error));
    }
}


export function* watchGetQuestionType(): any {
    yield takeEvery(QuestionTypesActionTypes.GET_QUESTION_TYPE, getQuestionType);
}

export function* watchListQuestionTypes(): any {
    yield takeEvery(QuestionTypesActionTypes.LIST_QUESTION_TYPES, listQuestionTypes);
}

export function* watchAddQuestionType():any{
    yield takeEvery(QuestionTypesActionTypes.ADD_QUESTION_TYPE,addQuestionType)
}
export function* watchUpdateQuestionType():any{
    yield takeEvery(QuestionTypesActionTypes.UPDATE_QUESTION_TYPE,updateQuestionType)
}
export function* watchDeleteQuestionType():any{
    yield takeEvery(QuestionTypesActionTypes.DELETE_QUESTION_TYPE,deleteQuestionType)
}


function* questionTypesSaga(): any {
    yield all([
        fork(watchGetQuestionType),
        fork(watchListQuestionTypes),
        fork(watchAddQuestionType),
        fork(watchUpdateQuestionType),
        fork(watchDeleteQuestionType),
    ]);
}

export default questionTypesSaga;
